import { Component, OnInit, ViewChild } from '@angular/core';
import { AssociateService } from '../../shared/services/associate.service';
import { TrainingService } from '../../shared/services/training.service';
import { Configuration } from '../../app.constants';
import { ToastService } from '../../shared/services/toast.service';
import { StaticValueService } from '../../shared/services/static-value.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Course} from '../trainingClass'
import { debounceTime } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { OrganizationService } from '../../shared/services/organization.service';
import { AuthService } from '../../shared/services/auth/auth.service';
import { DeletePopupComponent } from '../../shared/components/delete-popup/delete-popup.component';
import { MatDialog, Sort, MatPaginator } from '@angular/material';
import * as moment from 'moment';

@Component({
  selector: 'app-course-profile',
  templateUrl: './course-profile.component.html',
  styleUrls: ['./course-profile.component.css']
})
export class CourseProfileComponent implements OnInit {

  public training  = Object.assign({},new Course().object);
  public tempTraining: any;
  public associateList: any;
  public addedAssocaites=[];
  public serverApiUrl: string;
  public searchNameBeh = new BehaviorSubject<string>('');
  public searchNameObs = this.searchNameBeh.asObservable();

  @ViewChild('myForm')
  public myForm: NgForm ;
  public query: any;
  public search= {fullName:'', jobCategory:'',country:'',gender:'',company:''};
  public isProfileedit:Boolean = false;
  public staticDD:any;
  organizations: Object;
  public tempAssaociate={id:""};
  public user: any;
  public selectedAssociates = [];
  public bulkedit:Boolean = false;
  public isSearch = false;
  public searchQuery = {name:'', company:'', status: ''};
  public errors: any;
  public bulkStatus = "";
  public courseActive:Boolean = false;
  public isStarted:Boolean = false;
  public canEdit: Boolean = false;


  // paginator
  public pageSizeOptions = [ 5, 10, 15, 25, 50, 100];
  public pageSize = 10;
  public pageIndex = 0;
  public length =0;
  @ViewChild(MatPaginator) paginator: MatPaginator



  constructor(
    private associateService:AssociateService,
    private trainingService:TrainingService,
    public config: Configuration,
    public toastService:ToastService,
    public staticDDListService: StaticValueService,
    public activeRoute:ActivatedRoute,
    public organizationService: OrganizationService,
    public auth: AuthService,
    public dialog: MatDialog,
    public router:Router,

  ) {
    this.activeRoute.params.subscribe(param=>{
      this.trainingService.getCourse(param['id']).subscribe(data=>{
        
        this.training=Object.assign({},data[0]);
        if (moment(this.training.startDate).startOf('day').diff(moment().startOf('day'), 'days') <=0  && moment().startOf('day').diff(moment(this.training.endDate).startOf('day'), 'days') <= 0 ) {
          this.courseActive = true
        } else {
          this.courseActive = false;
        }
    
        if(moment(this.training.startDate).startOf('day').diff(moment().startOf('day'), 'days') <=0){
          this.isStarted = true;
        } 

        this.getAddedAssociate();
      })
    })


    if(this.auth.user.role === 'HR Manager' || this.auth.user.role === 'Admin'){
      this.canEdit = true;
    } else {
      this.isSearch = true;
    }

    this.staticDDListService.getStaticValues().then(data=>{
      this.staticDD = JSON.parse(JSON.stringify(data.staticDD));
      this.staticDDListService.getErrors().then(error=>{
        this.errors = error;
      });
    })

   }

  ngOnInit() {
    

    this.user = this.auth.user;
    this.serverApiUrl = this.config.StaticImageUrl;

    this.query = {
      search: {
          'active': true,
          'contractDetails.activeStatus': { $ne: 'Inactive' },
          'personalInformation.fullName': { '$regex': '', $options: 'i' },
          // 'team': ''
      },
      sort: { 'personalInformation.familyName': 1 },
      pagination: {
          pageIndex: 0,
          pageSize: 50
      }
    };




    this.searchNameObs.pipe(debounceTime(700)).subscribe(value => {
      if(this.isSearch === false){
        this.search.fullName = value;
        this.associateSearch();
      } else {
        this.searchQuery.name = value;
        this.searchAddedAssociate();
      }
    })

    this.organizationService.getOrganization().subscribe(orgs => {
      this.organizations = orgs;
    }, error => {});

    this.associateSearch();
    // this.associateService.getAllAssociates(0,20).subscribe(data => {
    //   this.associateList = data;
    // })
  }

  nameSearched() {
    if(this.isSearch){
      this.searchNameBeh.next(this.searchQuery.name);
    } else {
      this.searchNameBeh.next(this.search.fullName);
    }
  }


  getAddedAssociate(){
    this.query.search['_id']=this.training.associateIds.map(function(e) { return e.id; }),
    this.associateService.getAssociateSearch(0,50,this.query.search,this.query.sort).subscribe(data=>{
      this.addedAssocaites = data['data'];
      this.length = data['numberOfSelectedAssociates'];
      console.log('data 1',data)
    })
    delete this.query.search['_id'];
  }

  sortData(sort: Sort) {
    this.query.sort = {};
    if (sort.direction === 'asc') {
        this.query.sort[sort.active] = -1;
    } else if (sort.direction === 'desc') {
        this.query.sort[sort.active] = 1;
    }
    this.searchAddedAssociate();
  }

  associateSearch(){
    this.query.search['personalInformation.fullName'] = { $regex: this.search.fullName, $options: 'i' };
    this.query.search['jobDescription.company.id'] = { $regex: this.search.company, $options: 'i' };
    this.query.search['workContactDetails.workCountry'] = { $regex: this.search.country, $options: 'i' };
    this.query.search['jobDescription.jobCategory'] = { $regex: this.search.jobCategory, $options: 'i' };
    this.query.search['personalInformation.gender'] = this.search.gender;
    this.associateService.getAssociateSearch(0,50,this.query.search,this.query.sort).subscribe(data=>{
      this.associateList = data['data'];
    })
  }

  edit(){
    this.tempTraining = JSON.parse(JSON.stringify(this.training));
    this.isProfileedit = true;
  }

  acceptChanges(){
    const days = moment(this.tempTraining.startDate).diff(moment(), 'days');
    console.log('days',days,this.tempTraining.startDate)

    if(this.myForm.valid){
      if (moment(this.tempTraining.startDate).diff(moment(), 'days') <=0  && moment().diff(moment(this.tempTraining.endDate), 'days') <= 0 ) {
        this.courseActive = true
      } else {
        this.courseActive = false;
      }

      if(moment(this.tempTraining.startDate).startOf('day').diff(moment().startOf('day'), 'days') <=0){
        this.isStarted = true;
      } else {
        this.isStarted = false;
      }
      console.log(moment(this.tempTraining.startDate).startOf('day').diff(moment().startOf('day'), 'days'),moment(this.tempTraining.startDate).startOf('day'),moment().startOf('day'))

      this.training = JSON.parse(JSON.stringify(this.tempTraining));
      this.isProfileedit = false;
      this.update();
    }else {
      this.toastService.error(this.errors['Client']['401']);
    }
  }

  cancelChanges(){
    this.isProfileedit = false;
  }

  getAssociateStatus(id){

    const index= this.training.associateIds.map(function(e) { return e.id; }).indexOf(id);
    if(index !== -1){
      return this.training.associateIds[index]['status'];
    } else {
      return 'Not Started'
    }
  }


  update(){
    this.training.lastEditedBy.name = this.user.isProxyUser ? this.user.name + ` (${this.user.proxyUser.fullName})` : this.user.name;
    this.training.lastEditedBy.id = this.user.associateId;
    this.training.lastEditedBy.time = new Date();

    this.trainingService.updateCourse(this.training).subscribe(data=>{
      this.toastService.success();
    },error=>{
      this.toastService.error(this.errors['Server']['501']);
    });
  }

  addAssociate(associate){
    const index= this.training.associateIds.map(function(e) { return e.id; }).indexOf(associate._id);
    if(index === -1){
      this.training['associateIds'].push({id:associate._id,status:'In Progress'});
      this.addedAssocaites.push(associate);
      this.associateEdit(associate._id);
      this.update();
      this.searchAddedAssociate();
    } else {
      console.log('already exites')
    }
  }

  removeAssociate(associate){
    let dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '300px',
      data: {},
    });

    dialogRef.afterClosed().subscribe(response=>{
      if(response==='Proceed'){
        let index = this.addedAssocaites.indexOf(associate);
        this.addedAssocaites.splice(index,1);
        index= this.training.associateIds.map(function(e) { return e.id; }).indexOf(associate._id);
        this.training.associateIds.splice(index,1);
        this.update();
      }
    })

  }

  associateEdit(associateId){
    if(this.tempAssaociate.id){
      this.toastService.error(this.errors['General']['100']);
    } else {
      const index= this.training.associateIds.map(function(e) { return e.id; }).indexOf(associateId);
      if(index !== -1){
        this.tempAssaociate=JSON.parse(JSON.stringify(this.training.associateIds[index])) ;
      }  
    }
  }

  associateChangesCancel(){
    this.tempAssaociate.id="";
  }

  associateAccepted(){
    const index= this.training.associateIds.map(function(e) { return e.id; }).indexOf(this.tempAssaociate.id);
    this.training.associateIds[index]=JSON.parse(JSON.stringify(this.tempAssaociate));
    this.tempAssaociate.id="";
    this.update();
  }



  checkboxChange(event,associateId){
    if(event.target.checked){
      this.selectedAssociates.push(associateId);
    } else {
      let index = this.selectedAssociates.indexOf(associateId);
      this.selectedAssociates.splice(index,1);
    }
  }


  selectAllChange(event){
    if(event.target.checked){
      this.selectedAssociates = this.training.associateIds.map(function(e) { return e.id; })
    } else {
      this.selectedAssociates = [];
    }
  }

  archiveCourse(){
    let dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '300px',
      data: {},
    });

    dialogRef.afterClosed().subscribe(response=>{
      if(response==='Proceed'){
        this.trainingService.archiveCourse(this.training['_id']).subscribe(data=>{
          this.toastService.success();
          this.router.navigate(['/home/training/courses']);
         },error=>{
             this.toastService.error(this.errors['Server']['501']);
         })
      }
    })
  }

  bulkEditClick(){
    this.bulkedit = true;
    this.bulkStatus = "";
  }

  bulkAssociateEditCancel(){
    this.bulkedit = false;
  }

  selectedAssocicateStatusChange(){
    let dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '300px',
      data: {},
    });
    dialogRef.afterClosed().subscribe(response=>{
      if(response==='Proceed'){
        this.bulkedit = false;
        this.training.associateIds.forEach(temp =>{
          if (this.selectedAssociates.indexOf(temp.id) !== -1){
            temp.status = this.bulkStatus;
          }
        })
        this.update();
        console.log('selected assocaite status chnage')
      }
    })

  }

  selectedAssocicateRemoved(){
    let dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '300px',
      data: {},
    });
    dialogRef.afterClosed().subscribe(response=>{
      if(response==='Proceed'){
        this.selectedAssociates.forEach(associateId=>{
          let index = this.training.associateIds.map(function(e){return e.id}).indexOf(associateId);
          this.training.associateIds.splice(index,1);
        })
        this.selectedAssociates= [];
        this.getAddedAssociate();
        this.update();
        console.log('selected assocaite removed')
      }
    });
  }

  toggle(){
    this.paginator.pageIndex = 0;
    this.paginator.pageSize = 10;
    this.pageIndex = 0;
    this.pageSize = 10;
    this.getAddedAssociate();
  }

  searchAddedAssociate(){
    let tempSearchQuery = {};
      if(this.searchQuery.status === ""){
        tempSearchQuery['_id']= this.training.associateIds.map(function(e) { return e.id; });
      } else {
        tempSearchQuery['_id']= this.training.associateIds.filter(e => e.status === this.searchQuery.status ).map(function(e){ return e.id });
      }

      tempSearchQuery['jobDescription.company.id'] = { $regex: this.searchQuery.company, $options: 'i' };
      tempSearchQuery['personalInformation.fullName'] = { $regex: this.searchQuery.name, $options: 'i' };
      this.associateService.getAssociateSearch(this.pageIndex,this.pageSize,tempSearchQuery,this.query.sort).subscribe(data=>{
        console.log('data 2',data)
        this.addedAssocaites = data? data['data']: [];
        this.length = data? data['numberOfSelectedAssociates'] : 0;
      });
  }

  getServerData(event) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.searchAddedAssociate();
  }

}
